import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
// import constants from './constants'
import { I18nTranslate } from '@/i18n'

const routes: RouteRecordRaw[] = [
  {
    path: '/driver/empty-transfer',
    name: 'driverEmptyTransfer',
    component: () => import('@/pages/driver/transfer/EmptyTransfer.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Driver_Market_lUUD'),
    },
  },
  {
    path: '/driver',
    name: 'driver',
    component: () => import('@/pages/driver/index.vue'),
    children: [
      {
        path: 'center',
        name: 'driverCenter',
        component: () => import('@/pages/driver/center/index.vue'),
        meta: {
          title: I18nTranslate('Fleet_Phase1_Driver_Market_lUUD'),
        },
      },
      {
        path: 'im',
        name: 'driverIm',
        component: () => import('@/pages/driver/im/Messagelist.vue'),
        meta: {
          title: I18nTranslate('Fleet_Phase1_Message_iuXA'),
        },
      },
      {
        path: 'mine',
        name: 'driverMine',
        component: () => import('@/pages/driver/mine/index.vue'),
        meta: {
          title: I18nTranslate('Fleet_Phase1_My_information_gZpd'),
        },
      },
    ],
  },
  {
    path: '/driver/center/driver-info',
    name: 'driverInfo',
    component: () => import('@/pages/driver/center/DriverInfo.vue'),
    meta: {
      title: I18nTranslate('Fleet_report_Division_Information_capz'),
    },
  },
  {
    path: '/driver/im/select-vehicle',
    name: 'selectVehicle',
    component: () => import('@/pages/driver/im/VehicleList.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase2_Select_vehicle_DmgM'),
    },
  },
  {
    path: '/driver/im/bill-rules',
    name: 'billRules',
    component: () => import('@/pages/driver/im/BillRules.vue'),
    meta: {
      // title: I18nTranslate('Fleet_Phase2_Select_vehicle_DmgM'),
      title: 'Send Invitation Link',
    },
  },
  {
    path: '/driver/mine/setting',
    name: 'driverSetting',
    component: () => import('@/pages/driver/mine/Setting.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase3_Set_ozBm'),
    },
  },
  {
    path: '/driver/mine/tcinfo',
    name: 'driverTCInfo',
    component: () => import('@/pages/driver/mine/TCInfo.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/driver/mine/tcconfirm',
    name: 'driverTCConfirm',
    component: () => import('@/pages/driver/mine/TCConfirm.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/driver/mine/vehicle-info',
    name: 'driverVehicleInfo',
    component: () => import('@/pages/driver/mine/VehicleInfo.vue'),
    meta: {
      title: I18nTranslate('vehicle_info'),
    },
  },
  {
    path: '/driver/mine/my-info',
    name: 'driverMyInfo',
    component: () => import('@/pages/driver/mine/MyInfo.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Personal_information_rOpp'),
    },
  },
  {
    path: '/driver/mine/rent',
    name: 'driverRent',
    component: () => import('@/pages/driver/mine/Rent.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Select_vehicle_eTyy'),
    },
  },
  {
    path: '/driver/mine/add-first',
    name: 'driverAddFirst',
    component: () => import('@/pages/driver/mine/RentFirst.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Vehicter_vehicles_KaSk'),
    },
  },
  {
    path: '/driver/mine/default-image',
    name: 'driverAddDefaultImage',
    component: () => import('@/pages/driver/mine/DefaultImage.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Default_image_AFLD'),
    },
  },
  {
    path: '/driver/mine/add-second',
    name: 'driverAddSecond',
    component: () => import('@/pages/driver/mine/RentSecond.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Lease_Information_AcRo'),
    },
  },
  {
    path: '/driver/mine/add-third',
    name: 'driverAddThird',
    component: () => import('@/pages/driver/mine/MyInfo.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Personal_information_rOpp'),
    },
  },
  {
    path: '/driver/mine/pick-address',
    name: 'driverPickAddress',
    component: () => import('@/pages/driver/mine/pickAddress/index.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase3_Pick_up_fDQC'),
    },
  },
  {
    path: '/driver/mine/setting-pick-address',
    name: 'driverSettingPickAddress',
    component: () => import('@/pages/driver/mine/pickAddress/index.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase3_Pick_up_fDQC'),
    },
  },
  {
    path: '/driver/mine/add-address',
    name: 'driverAddAddress',
    component: () => import('@/pages/driver/mine/pickAddress/AddAddress.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase3_Add_pickup_rHID'),
    },
  },
  {
    path: '/driver/mine/edit-address',
    name: 'driverEditAddress',
    component: () => import('@/pages/driver/mine/pickAddress/AddAddress.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase3_Add_pickup_rHID'),
    },
  },
  {
    path: '/driver/im/dialog',
    name: 'driverDialog',
    component: () => import('@/pages/driver/im/Dialog.vue'),
    meta: {
      // title: I18nTranslate('Fleet_Phase1_My_resume_XrBM'),
      title: 'Driver Melvin',
    },
  },
  {
    path: '/driver/im/invite-detail',
    name: 'driverInviteDetail',
    component: () => import('@/pages/driver/im/InviteDetail.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase2_Invitation_to_XuMK'),
    },
  },
  {
    path: '/driver/im/driver-info',
    name: 'driverImDriverInfo',
    component: () => import('@/pages/driver/im/DriverInfo.vue'),
    meta: {
      title: I18nTranslate('Fleet_report_Division_Information_capz'),
    },
  },
  {
    path: '/driver/im/vehicle-info',
    name: 'driverImVehicleInfo',
    component: () => import('@/pages/driver/im/VehicleInfo.vue'),
    meta: {
      title: I18nTranslate('vehicle_info'),
    },
  },

  {
    path: '/vehicle/transfer',
    name: 'vehicleTransfer',
    component: () => import('@/pages/vehicle/transfer/index.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Vehicle_market_bycj'),
    },
  },
  {
    path: '/vehicle/empty-transfer',
    name: 'vehicleEmptyTransfer',
    component: () => import('@/pages/vehicle/transfer/EmptyTransfer.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Vehicle_market_bycj'),
    },
  },
  {
    path: '/vehicle',
    name: 'vehicle',
    component: () => import('@/pages/vehicle/index.vue'),
    children: [
      {
        path: 'center',
        name: 'vehicleCenter',
        component: () => import('@/pages/vehicle/center/index.vue'),
        meta: {
          title: I18nTranslate('Fleet_Phase1_Vehicle_market_bycj'),
        },
      },
      {
        path: 'im',
        name: 'vehicleIm',
        component: () => import('@/pages/vehicle/im/Messagelist.vue'),
        meta: {
          title: I18nTranslate('Fleet_Phase1_Message_iuXA'),
        },
      },
      {
        path: 'mine',
        name: 'vehicleMine',
        component: () => import('@/pages/vehicle/mine/index.vue'),
        meta: {
          title: I18nTranslate('Fleet_Phase1_My_message_SfLZ'),
        },
      },
    ],
  },
  {
    path: '/vehicle/center/vehicle-info',
    name: 'vehicleInfo',
    component: () => import('@/pages/vehicle/center/VehicleInfo.vue'),
    meta: {
      title: I18nTranslate('vehicle_info'),
    },
  },
  {
    path: '/vehicle/center/banner-info',
    name: 'BannerInfo',
    component: () => import('@/pages/vehicle/center/BannerInfo.vue'),
    meta: {
      title: '',
    },
  },
  // {
  //   path: '/vehicle/im/messagelist',
  //   name: 'VehicleMessageList',
  //   component: () => import('@/pages/vehicle/im/Messagelist.vue'),
  //   meta: {
  //     title: 'Message',
  //   },
  // },
  {
    path: '/vehicle/mine/setting',
    name: 'vehicleSetting',
    component: () => import('@/pages/vehicle/mine/Setting.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase3_Set_ozBm'),
    },
  },
  {
    path: '/vehicle/mine/tcinfo',
    name: 'vehicleTCInfo',
    component: () => import('@/pages/vehicle/mine/TCInfo.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/vehicle/mine/tcconfirm',
    name: 'vehicleTCConfirm',
    component: () => import('@/pages/vehicle/mine/TCConfirm.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/vehicle/mine/resume',
    name: 'vehicleResume',
    component: () => import('@/pages/vehicle/mine/Resume.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_My_resume_XrBM'),
    },
  },
  {
    path: '/vehicle/mine/download-info',
    name: 'downloadInfo',
    component: () => import('@/pages/vehicle/mine/Download.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase3__ZGux'),
    },
  },
  {
    path: '/vehicle/im/dialog',
    name: 'vehicleDialog',
    component: () => import('@/pages/vehicle/im/Dialog.vue'),
    meta: {
      // title: I18nTranslate('Fleet_Phase1_My_resume_XrBM'),
      title: 'Vincent Melvin',
    },
  },
  {
    path: '/vehicle/im/invite-detail',
    name: 'vehicleInviteDetail',
    component: () => import('@/pages/vehicle/im/InviteDetail.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase2_Invitation_to_XuMK'),
    },
  },
  {
    path: '/vehicle/im/invite-transfer',
    name: 'vehicleInviteTransfer',
    component: () => import('@/pages/vehicle/im/InviteTransfer.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase2_Invitation_to_XuMK'),
    },
  },
  {
    path: '/vehicle/im/invite-ob',
    name: 'vehicleInviteOB',
    component: () => import('@/pages/vehicle/im/OBPage.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase3__xZGP'),
    },
  },
  {
    path: '/vehicle/im/driver-info',
    name: 'vehicleImDriverInfo',
    component: () => import('@/pages/vehicle/im/DriverInfo.vue'),
    meta: {
      title: I18nTranslate('Fleet_report_Division_Information_capz'),
    },
  },
  {
    path: '/vehicle/im/vehicle-info',
    name: 'vehicleImVehicleInfo',
    component: () => import('@/pages/vehicle/im/VehicleInfo.vue'),
    meta: {
      title: I18nTranslate('vehicle_info'),
    },
  },

  {
    path: '/test',
    name: 'Test',
    component: () => import('@/pages/ztest/index.vue'),
  },

  {
    path: '/:patchMatch(.*)',
    name: 'errorPage',
    component: () => import('@/pages/empty/index.vue'),
    meta: {
      title: I18nTranslate('Fleet_Phase1_Driver_Market_lUUD'),
    },
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.afterEach((to, from) => {
  // 同步修正document.title
  const title = to?.meta?.title || 'Matching Market'
  const globalWindow = window as any
  globalWindow.document.title = title
})

export default router
